import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "w-full bg-gray-100 border-gray-200 py-2.5 dark:bg-gray-800" };
const _hoisted_2 = { class: "max-w-full w-full max-lg:hidden lg:flex flex-wrap items-center justify-between px-4 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "flex items-center h-[50px]" };
const _hoisted_4 = {
    key: 0,
    class: "w-96 xl:w-140 max-w-4xl",
    "data-testid": "navbar-search"
};
const _hoisted_5 = { class: "flex items-center justify-between gap-3" };
const _hoisted_6 = { class: "min-w-0 flex-1" };
const _hoisted_7 = { class: "text-sm text-gray-900 dark:text-gray-100 truncate" };
const _hoisted_8 = { class: "font-medium text-gray-600 dark:text-gray-400" };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "text-xs text-gray-600 dark:text-gray-300 truncate mt-1" };
const _hoisted_11 = { class: "font-medium" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { class: "shrink-0 text-right" };
const _hoisted_14 = { class: "text-sm font-semibold text-gray-900 dark:text-gray-100" };
const _hoisted_15 = { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" };
const _hoisted_16 = { class: "flex items-center space-x-2 xl:space-x-3 2xl:space-x-4 shrink-0" };
const _hoisted_17 = { class: "shrink-0" };
const _hoisted_18 = {
    key: 0,
    class: "shrink-0"
};
const _hoisted_19 = {
    key: 1,
    class: "shrink-0"
};
const _hoisted_20 = { class: "lg:hidden" };
const _hoisted_21 = { class: "flex items-center justify-between h-16 px-4 sm:px-6 border-b border-gray-200 dark:border-gray-600" };
const _hoisted_22 = { class: "flex items-center space-x-2" };
const _hoisted_23 = { class: "shrink-0" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const _hoisted_26 = {
    key: 0,
    class: "px-4 sm:px-6 py-4"
};
const _hoisted_27 = { class: "flex items-center justify-between gap-3" };
const _hoisted_28 = { class: "min-w-0 flex-1" };
const _hoisted_29 = { class: "text-sm text-gray-900 dark:text-gray-100 truncate" };
const _hoisted_30 = { class: "font-medium text-gray-600 dark:text-gray-400" };
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = { class: "text-xs text-gray-600 dark:text-gray-300 truncate mt-1" };
const _hoisted_33 = { class: "font-medium" };
const _hoisted_34 = ["innerHTML"];
const _hoisted_35 = { class: "shrink-0 text-right" };
const _hoisted_36 = { class: "text-sm font-semibold text-gray-900 dark:text-gray-100" };
const _hoisted_37 = { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" };
const _hoisted_38 = { class: "print-header" };
const _hoisted_39 = { class: "print-header-content" };
const _hoisted_40 = { class: "print-logo" };
const _hoisted_41 = ["src", "alt"];
const _hoisted_42 = { class: "print-title truncate max-w-[300px]" };
const _hoisted_43 = { class: "space-y-4" };
const _hoisted_44 = { class: "space-y-2" };
const _hoisted_45 = { class: "bg-gray-50 dark:bg-gray-600 p-3 rounded-lg" };
const _hoisted_46 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" };
const _hoisted_47 = { class: "text-sm text-gray-900 dark:text-gray-100 font-mono" };
const _hoisted_48 = { class: "bg-gray-50 dark:bg-gray-600 p-3 rounded-lg" };
const _hoisted_49 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" };
const _hoisted_50 = { class: "text-sm text-gray-900 dark:text-gray-100 font-mono" };
const _hoisted_51 = { class: "bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 p-3 rounded-lg" };
const _hoisted_52 = { class: "text-sm text-blue-800 dark:text-blue-200" };
import { computed, ref } from "vue";
import LocaleSelector from "./LocaleSelector.vue";
import SearchBar from "./navBar/SearchBar.vue";
import UserAvatar from "./navBar/UserAvatar.vue";
import AccountStatusIcon from "./navBar/AccountStatusIcon.vue";
import ConfirmModal from "./ConfirmModal.vue";
import { useI18n } from "vue-i18n";
import { usePaymentStore } from "@/stores/paymentStore";
import TransactionSearchService from "@/infrastructure/services/TransactionSearchService";
import { useRouter, useRoute } from "vue-router";
import { useAccountInfo } from "@/shared/composables/useAccountInfo";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavBar',
    props: {
        variant: { default: "onboarding" }
    },
    setup(__props) {
        // Store and i18n
        const { t } = useI18n();
        const paymentStore = usePaymentStore();
        const router = useRouter();
        const route = useRoute();
        // Account info for status display
        const { showOnboardingIcon } = useAccountInfo();
        // Organization info computed property with fallback
        const organizationInfo = computed(() => paymentStore.organizationInfo || {});
        // Modal state for missing transaction ID error
        const showMissingIdModal = ref(false);
        const selectedTransaction = ref(null);
        const hasOrganizationLogo = computed(() => !!organizationInfo.value?.opayAccountLogo);
        const organizationName = computed(() => organizationInfo.value?.opayAccountName || "Eudonet");
        function formatAmount(amount, currency) {
            try {
                // Uses browser's default locale when undefined is passed as first parameter
                return new Intl.NumberFormat(undefined, {
                    style: "currency",
                    currency,
                }).format(amount / 100);
            }
            catch {
                return `${(amount / 100).toFixed(2)} ${currency}`;
            }
        }
        async function searchTransactions(q) {
            return await TransactionSearchService.search(q);
        }
        function onSelectTransaction(item) {
            // Check if adyenTransactionId is missing or empty
            if (!item.adyenTransactionId || item.adyenTransactionId.trim() === "") {
                selectedTransaction.value = item;
                showMissingIdModal.value = true;
                return;
            }
            router
                .push({
                path: "/dashboard/transactions",
                query: { ...route.query, transactionId: item.adyenTransactionId },
            })
                .catch(() => { });
        }
        function closeMissingIdModal() {
            showMissingIdModal.value = false;
            selectedTransaction.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (__props.variant === 'dashboard')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(SearchBar, {
                                    "search-fn": searchTransactions,
                                    "get-item-key": (i) => i.adyenTransactionId,
                                    placeholder: _unref(t)('dashboard.searchPlaceholder'),
                                    "searching-text": _unref(t)('dashboard.transactions.searching'),
                                    "no-results-text": _unref(t)('dashboard.transactions.noResults'),
                                    onSelect: onSelectTransaction
                                }, {
                                    result: _withCtx(({ item, highlight }) => [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("p", _hoisted_7, [
                                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("adyen.customFields.paymentPspReference")) + " :", 1 /* TEXT */),
                                                    _createElementVNode("span", {
                                                        class: "ml-1",
                                                        innerHTML: highlight(item.pspReference)
                                                    }, null, 8 /* PROPS */, _hoisted_9)
                                                ]),
                                                _createElementVNode("p", _hoisted_10, [
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("adyen.customFields.merchantId")) + " :", 1 /* TEXT */),
                                                    _createElementVNode("span", {
                                                        class: "ml-1",
                                                        innerHTML: highlight(item.merchantId || '-')
                                                    }, null, 8 /* PROPS */, _hoisted_12)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, _toDisplayString(formatAmount(item.amount, item.currency)), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_15, _toDisplayString(item.currency), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["get-item-key", "placeholder", "searching-text", "no-results-text"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(LocaleSelector)
                        ]),
                        (__props.variant === 'dashboard' && _unref(showOnboardingIcon))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(AccountStatusIcon)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (__props.variant === 'dashboard')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(UserAvatar)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(LocaleSelector)
                            ]),
                            (__props.variant === 'dashboard' && _unref(showOnboardingIcon))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(AccountStatusIcon)
                                ]))
                                : _createCommentVNode("v-if", true),
                            (__props.variant === 'dashboard')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(UserAvatar)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    (__props.variant === 'dashboard')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(SearchBar, {
                                "search-fn": searchTransactions,
                                "get-item-key": (i) => i.adyenTransactionId,
                                placeholder: _unref(t)('dashboard.searchPlaceholder'),
                                "searching-text": _unref(t)('dashboard.transactions.searching'),
                                "no-results-text": _unref(t)('dashboard.transactions.noResults'),
                                onSelect: onSelectTransaction
                            }, {
                                result: _withCtx(({ item, highlight }) => [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("p", _hoisted_29, [
                                                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)("adyen.customFields.paymentPspReference")) + " :", 1 /* TEXT */),
                                                _createElementVNode("span", {
                                                    class: "ml-1",
                                                    innerHTML: highlight(item.pspReference)
                                                }, null, 8 /* PROPS */, _hoisted_31)
                                            ]),
                                            _createElementVNode("p", _hoisted_32, [
                                                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)("adyen.customFields.merchantId")) + " :", 1 /* TEXT */),
                                                _createElementVNode("span", {
                                                    class: "ml-1",
                                                    innerHTML: highlight(item.merchantId || '-')
                                                }, null, 8 /* PROPS */, _hoisted_34)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, _toDisplayString(formatAmount(item.amount, item.currency)), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_37, _toDisplayString(item.currency), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["get-item-key", "placeholder", "searching-text", "no-results-text"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                            (hasOrganizationLogo.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: organizationInfo.value?.opayAccountLogo,
                                    alt: organizationName.value,
                                    class: "print-logo-img"
                                }, null, 8 /* PROPS */, _hoisted_41))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(organizationName.value), 1 /* TEXT */)
                        ])
                    ])
                ]),
                (selectedTransaction.value)
                    ? (_openBlock(), _createBlock(ConfirmModal, {
                        key: 0,
                        "is-visible": showMissingIdModal.value,
                        title: _unref(t)('dashboard.transactions.missingIdModal.title'),
                        message: _unref(t)('dashboard.transactions.missingIdModal.message'),
                        "confirm-text": _unref(t)('dashboard.transactions.missingIdModal.close'),
                        type: "error",
                        "show-cancel-button": false,
                        onConfirm: closeMissingIdModal,
                        onClose: closeMissingIdModal
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(t)("dashboard.transactions.missingIdModal.merchantIdLabel")) + ": ", 1 /* TEXT */),
                                        _createElementVNode("p", _hoisted_47, _toDisplayString(selectedTransaction.value.merchantId || "-"), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(t)("dashboard.transactions.missingIdModal.pspReferenceLabel")) + ": ", 1 /* TEXT */),
                                        _createElementVNode("p", _hoisted_50, _toDisplayString(selectedTransaction.value.pspReference), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(t)("dashboard.transactions.missingIdModal.alternativeMessage")), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-visible", "title", "message", "confirm-text"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
